// src/data/notebooks.js
// Ab backend se fetch hota hai (teeno notebook categories merge karke), static array nahi.

const API_BASE = "https://aishcraft.com/backend/api";
const NOTEBOOK_CATEGORY_SLUGS = ["lined-notebook", "plain-notebook", "dotted-notebook"];

export const PRODUCTS_PER_PAGE = 12;

let _cache = null;
let _cachePromise = null;

async function fetchOneCategory(slug) {
  const res = await fetch(`${API_BASE}/public/products.php?category=${slug}`);
  const json = await res.json();
  if (json.success === false) throw new Error(json.message || "Failed to load products");
  return json.data || [];
}

async function fetchNotebooks() {
  if (_cache) return _cache;
  if (_cachePromise) return _cachePromise;

  _cachePromise = Promise.all(NOTEBOOK_CATEGORY_SLUGS.map(fetchOneCategory))
    .then(results => {
      const merged = results.flat();
      // De-duplicate by dbId just in case
      const seen = new Set();
      _cache = merged.filter(p => {
        if (seen.has(p.dbId)) return false;
        seen.add(p.dbId);
        return true;
      });
      return _cache;
    })
    .catch(err => {
      _cachePromise = null;
      throw err;
    });

  return _cachePromise;
}

export async function getNotebooks() {
  return fetchNotebooks();
}

export async function getProductBySlug(slug) {
  const products = await fetchNotebooks();
  return products.find(p => p.id === slug);
}

export async function getRelatedProducts(slug, count = 4) {
  const products = await fetchNotebooks();
  const current = products.find(p => p.id === slug);
  if (!current) return [];
  const pool = products.filter(p => p.id !== slug);
  const sameTag = pool.filter(p => p.tag === current.tag);
  const rest = pool.filter(p => p.tag !== current.tag);
  return [...sameTag, ...rest].slice(0, count);
}